import * as ctrlsConstants from "src/app/shared/_config/ctrls/ctrls-constants";
import { ExtSharedDeliveryI } from "./shared-delivery.result.ext";
import { SharedDeliveryI } from "./shared-delivery.result.int";
import { ExtSharedDeliveryQueryI } from "./shared-delivery.query.ext";
import { SharedDeliveryQueryI } from "./shared-delivery.query.int";
import { valuePairToValue } from "@softpak/components/spx-helpers";

export const MapSharedDelivery = {
    mapQuery: (int: SharedDeliveryQueryI): ExtSharedDeliveryQueryI => ({
      request: {
        filter: JSON.stringify({
          filter: {
            logic: 'and',
            filters: [
              {
                field: 'deliveryid',
                operator: 'eq',
                value: encodeURIComponent(valuePairToValue(int.deliveryId)),
              }
            ]
          },
        }),
    },
    }),
    mapResult: (ext: ExtSharedDeliveryI): SharedDeliveryI => {
      const result = (ext.response.dsDelivery?.ttDelivery ? ext.response.dsDelivery?.ttDelivery : []);

        if (result.length === 1) {
          return {
              [ctrlsConstants.ctrlDeliveryId]: { value: result[0].deliveryid },
              [ctrlsConstants.ctrlBookingNumber]: { value: result[0].deliverynumber },
          };
        }
    },       
};
